import "./drawerStats.css";

const GRADES = [
  { name: "Outstanding", tone: "outstanding" },
  { name: "Good", tone: "good" },
  { name: "Requires improvement", tone: "requires" },
  { name: "Inadequate", tone: "inadequate" },
];

function matchGrade(text) {
  const value = String(text || "").trim().toLowerCase().replace(/\s+/g, " ");
  if (value === "requiresimprovement") return 2;
  return GRADES.findIndex((grade) => value === grade.name.toLowerCase());
}

/** Four published grades. The school’s grade is filled; the others stay pale. */
export default function GradeScale({ grade }) {
  const index = matchGrade(grade);

  return (
    <div
      className="ds-ofsted"
      role="img"
      aria-label={index >= 0 ? `Published grade: ${GRADES[index].name}` : "No single overall grade"}
    >
      {GRADES.map((item, step) => (
        <span
          key={item.name}
          className={`ds-ofsted-step ds-ofsted-step--${item.tone}${step === index ? " is-on" : ""}`}
        >
          {item.name}
        </span>
      ))}
    </div>
  );
}
